export const formatRichiestaDescrizioneLabel = (richiesta) => {
  let text = String(richiesta || "").trim();
  if (!text) return "";

  text = text
    .replace(/^[xp]\s*/i, "")
    .replace(/^note:\s*/i, "")
    .trim();

  const outerParentheses = text.match(/^\((.*)\)$/);
  if (outerParentheses) text = outerParentheses[1].trim();

  text = text
    .replace(/^note:\s*/i, "")
    .replace(/[()]/g, "")
    .replace(/\s+/g, " ")
    .trim();

  return text && !/^[xp]$/i.test(text) ? text : "";
};
